import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import arrow from 'assets/red-arrow.png';
import domains from 'global';
import styles from './Header.module.css';
import HeaderForm from './HeaderForm';
import ReactPlayer from 'react-player';
export default function Header(_a) {
    var _b, _c, _d;
    var project = _a.project;
    var _e = useState(0), positionY = _e[0], setPositionY = _e[1];
    var video = useRef(null);
    var image = useRef(null);
    var t = useTranslation().t;
    useLayoutEffect(function () {
        var element = video.current || image.current;
        if (element) {
            var top = element.getBoundingClientRect().top;
            if (top && top !== 0) {
                if (top > 0) {
                    setPositionY(top);
                }
                else {
                    setPositionY(document.documentElement.scrollHeight - window.innerHeight + top);
                }
            }
            else {
                var observer_1 = new IntersectionObserver(function (entries) {
                    if (entries[0].isIntersecting) {
                        var top_1 = entries[0].boundingClientRect.top;
                        if (top_1 > 0) {
                            setPositionY(top_1);
                        }
                        else {
                            setPositionY(document.documentElement.scrollHeight - window.innerHeight + top_1);
                        }
                        observer_1.disconnect();
                    }
                });
                observer_1.observe(element);
                return function () { return observer_1.disconnect(); };
            }
        }
    }, []);
    return (_jsxs(_Fragment, { children: [(positionY && positionY !== 0)
                && (_jsx("div", { className: styles.desktop, children: _jsx(HeaderForm, { project: project, top: positionY }) })), _jsxs("header", { className: "content ".concat(styles.header), children: [_jsxs("h1", { className: styles.title, children: [_jsx("span", { children: t("header.title.1") }), _jsx("span", { children: t("header.title.2") })] }), _jsx("div", { className: styles.row, children: _jsxs("div", { className: styles['video-wrapper'], children: [project.cover || !project.project_page || ((_b = project.project_page) === null || _b === void 0 ? void 0 : _b.cover) === '' ? _jsx("img", { src: ((_c = project.project_page) === null || _c === void 0 ? void 0 : _c.cover) || "".concat(domains.media, "/api/media/public/landing_page/cover_default.jpg"), alt: "".concat(project.name, "'s team"), className: styles.video, ref: image }) : _jsx(_Fragment, { children: _jsx("div", { ref: video, children: _jsx(ReactPlayer, { url: (_d = project.project_page) === null || _d === void 0 ? void 0 : _d.cover, className: styles.video, width: "560", height: "315" }) }) }), _jsx("img", { src: arrow, alt: "red arrow", className: styles.arrow })] }) }), _jsx("div", { className: styles.mobile, children: _jsx(HeaderForm, { project: project }) })] })] }));
}
